import React, { FC, ReactNode } from 'react';

type Props = {
  className: string;
  id?: string;
  children?: ReactNode;
};

const Modal: FC<Props> = ({ children, id, className }) => (
  <div
    id={id}
    className={`${className} Modal relative bg-white flex-grow w-full mb-auto md:mt-auto flex flex-col md:mx-20 max-w-lg lg:my-auto`}
  >
    {children}
  </div>
);

export default Modal;
